import { Component, inject, OnInit } from '@angular/core'
import { ClassService } from '@account/Services/ClassService'
import Class, {
	TRIO_QUARTET,
	DUET,
	GROUP,
	MINI_GROUP,
	SOLO,
} from '@account/Class'
import Pagination from '@ui/Pagination'
import { InputValue } from '@ui/Components/Form/TextInput/TextInput.Component'
import {
	SelectComponent,
	SelectItem,
	SelectValue,
} from '@ui/Components/Form/Select/Select.Component'
import HttpError from '@ui/HttpError'
import { PageComponent } from '@account/Components/ui/Page/Page.Component'
import { PaginatorComponent } from '@ui/Components/Paginator/Paginator.Component'
import { DebouncedTextFilterComponent } from '@ui/Components/Filters/DebouncedTextFilter.Component'
import { ClassesTableComponent } from '@account/Components/Classes/Table/ClassesTable.Component'
import { CategoryService } from '@account/Services/CategoryService'
import ClassCategory from '@account/ClassCategory'

@Component({
	selector: 'classes-component',
	templateUrl: './Classes.Component.html',
	styleUrls: ['./Classes.Component.css'],
	imports: [
		PageComponent,
		PaginatorComponent,
		DebouncedTextFilterComponent,
		SelectComponent,
		ClassesTableComponent,
	],
})
export class ClassesComponent implements OnInit {
	public classes: Class[] = []

	public types: SelectItem[] = [
		{ label: 'Select...', value: undefined },
		{ label: 'Solo', value: SOLO },
		{ label: 'Duet', value: DUET },
		{ label: 'Trio/Quartet', value: TRIO_QUARTET },
		{ label: 'Mini Group', value: MINI_GROUP },
		{ label: 'Group', value: GROUP },
	]

	public classService: ClassService

	protected selectCategories: SelectItem[] = []

	private readonly categoryService: CategoryService

	constructor() {
		this.classService = inject(ClassService)
		this.categoryService = inject(CategoryService)
	}

	public ngOnInit() {
		this.classService.setLocalStorageKey('a-classes-page').resetFilter()

		this.getCategories()

		this.getClasses(false)
	}

	public setPaginator = (paginator: Pagination) => {
		this.classService.paginator = paginator
		this.getClasses(false)
	}

	public filterNumber = async (number: InputValue) => {
		this.classService.filterable.class_number = number as string

		await this.getClasses()
	}

	public filterClassName = async (input: InputValue) => {
		this.classService.filterable.name = input as string

		await this.getClasses()
	}

	public filterCategory = async (input: SelectValue) => {
		this.classService.filterable.category.id = input as number

		await this.getClasses()
	}

	public filterClassType = async (input: InputValue) => {
		this.classService.filterable.type = input as string

		await this.getClasses()
	}

	private readonly getClasses = async (resetPaginator = true) => {
		try {
			if (resetPaginator) {
				this.classService.paginatorInit(true)
			}

			this.classes = await this.classService.filter()
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}

	private readonly getCategories = async () => {
		try {
			this.categoryService.clearLocalStorageKey().resetFilter()

			this.classService.paginatorInit(true)

			this.categoryService.paginator.per_page = 999

			const categories = await this.categoryService.filter()

			this.selectCategories = categories.map(
				(category: ClassCategory): SelectItem => ({
					label: category.name,
					value: category.id,
				}),
			)

			this.selectCategories.unshift({
				label: 'Select...',
				value: undefined,
			})
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
